import { Injectable } from '@angular/core';
import { MEDDICScoreSource } from '../meddic-scores/m-e-d-d-i-c-score-source';
import { Observable } from 'rxjs';
import { MEDDICSection, MEDDICSectionData } from '@vendasta/sales-opportunities';

export interface SaveMEDDICNotesRequest {
  accountGroupId: string;
  opportunityId: string;
  editSalesPersonId: string;
  section: MEDDICSection;
  notes: string;
}

@Injectable()
export class MeddicNotesService {
  private readonly lastNotesUpdateAttemptedMap = new Map<string, SaveMEDDICNotesRequest>();

  constructor(private readonly meddicDataProvider: MEDDICScoreSource) {}

  saveMEDDICNotes(request: SaveMEDDICNotesRequest): void {
    this.lastNotesUpdateAttemptedMap.set(request.opportunityId, request);
    this.meddicDataProvider.submitMEDDICNotes(
      request.accountGroupId,
      request.opportunityId,
      request.editSalesPersonId,
      request.section,
      request.notes,
    );
  }

  retrySavingMEDDICNotes(id: string): void {
    const request = this.lastNotesUpdateAttemptedMap.get(id);
    this.saveMEDDICNotes(request);
  }

  didNotesSaveSuccessfully$(id: string): Observable<boolean> {
    return this.meddicDataProvider.didNotesSaveSuccessfully$(id);
  }

  areNotesCurrentlySaving$(id: string): Observable<boolean> {
    return this.meddicDataProvider.areNotesCurrentlySaving$(id);
  }

  areSectionsCurrentlyLoading$(id: string): Observable<boolean> {
    return this.meddicDataProvider.areSectionsCurrentlyLoading$(id);
  }

  didSectionsLoadSuccessfully(id: string): Observable<boolean> {
    return this.meddicDataProvider.didSectionsLoadSuccessfully(id);
  }

  getMeddicSections(opportunityId: string): Observable<MEDDICSectionData[]> {
    return this.meddicDataProvider.getMeddicSections(opportunityId);
  }

  initializeMeddicSections(accountGroupId: string, opportunityId: string): void {
    return this.meddicDataProvider.initializeMeddicSections(accountGroupId, opportunityId);
  }
}
